/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardPoolSetting
 */
export interface CardPoolSetting {
    /**
     * 
     * @type {string}
     * @memberof CardPoolSetting
     */
    cardPoolId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardPoolSetting
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardPoolSetting
     */
    cardType?: string | null;
}

export function CardPoolSettingFromJSON(json: any): CardPoolSetting {
    return CardPoolSettingFromJSONTyped(json, false);
}

export function CardPoolSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardPoolSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardPoolId': !exists(json, 'cardPoolId') ? undefined : json['cardPoolId'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'cardType': !exists(json, 'cardType') ? undefined : json['cardType'],
    };
}

export function CardPoolSettingToJSON(value?: CardPoolSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardPoolId': value.cardPoolId,
        'currency': value.currency,
        'cardType': value.cardType,
    };
}


